export default __webpack_public_path__ + "static/media/gallery-wip-emitter_11.49a05cfa.jpg";